<template>
  <section>
    <div id="slider" v-if="media">
      <input checked="" type="radio" name="slider"
        :id="`slide${index}`" selected="false"
        v-on:change="slideTo(index)"
        v-for="(item, index) in media" :key="index">
      <div id="slides">
        <div id="overflow">
          <div class="inner" :style="{width: `${media.length * 100}%`,
            marginLeft: `-${mLeft}%`}">
            <article v-for="(item, index) in media" :key="index"
              :style="{width: `${100 / media.length}%`}">
              <img decoding="auto" sizes="600px"
                :src="item.media.imageLg"
                style="object-fit: cover;">
            </article>
          </div> <!-- .inner -->
        </div> <!-- #overflow -->
      </div>
      <div class="l" v-if="currentPos > 0"
        v-on:click="slideTo(currentPos - 1)"></div>
      <div class="r" v-if="currentPos < media.length - 1"
        v-on:click="slideTo(currentPos + 1)"></div>
      <div class="pager">
        <label :for="`slide${index}`" v-for="(item, index) in media" :key="index"
          :class="{active: currentPos === index}"></label>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {
  },
  props: ['media'],
  data() {
    return {
      mLeft: 0,
      currentPos: 0,
    };
  },
  methods: {
    slideTo(i) {
      this.mLeft = i * 100;
      this.currentPos = i;
    },
    resetSlide() {
      this.mLeft = 0;
      this.currentPos = 0;
    },
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.pager{
  position: absolute;
  left: 0; right: 0; bottom: 10px;
  z-index: 2;
  label{
    background: rgba(255,255,255,.4);
    display: inline-block;
    cursor: pointer;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 3px;
    &:hover{
      background: #fff;
    }
    &.active{
      background: #fff;
    }
  }
}
.l, .r{
  position: absolute;
  top: 50%;
  width: 38px; height: 38px;
  margin-top: -19px;
  background-color: rgba(0,0,0,.7);
  border-radius: 50%;
  cursor: pointer;
  background-size: 18px auto;
  background-repeat: no-repeat;
  opacity: .4;
  transition: all .3s ease;
  &:hover{
    opacity: .8;
  }
}
.l{
  left: 10px;
  background-image: url(../assets/arrow-left-white.png);
  background-position: 9px 50%;
}
.r{
  right: 10px;
  background-image: url(../assets/arrow-right-white.png);
  background-position: 11px 50%;
}
#slider {
  max-width: 600px;
  max-height: 600px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  @media (max-width: 990px) {
    max-width: 100vw;
    max-height: 100vw;
  }
}

#overflow {
  width: 100%;
  overflow: hidden;
}

#slides .inner {
  width: 400%;
}

#slides .inner {
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -o-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);

  -webkit-transition: all 800ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -moz-transition: all 800ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -o-transition: all 800ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -ms-transition: all 800ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
  transition: all 800ms cubic-bezier(0.770, 0.000, 0.175, 1.000);

  -webkit-transition-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -moz-transition-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -o-transition-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -ms-transition-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
  transition-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
}

#slides article {
  width: 25%;
  float: left;
  img{
    height: 600px;
    @media (max-width: 990px) {
      height: 100vw;
    }
  }
}

input[type="radio"] {
  display: none;
}
</style>
